import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { AvailabilityBlock } from "@/models/availability-block.model.ts"
import { type IAvailabilityBlock } from "@/interfaces/api/availability-block.interface.ts"
import { AvailabilityBlockRepository } from "@/repositories/availability-block-repository.ts"
import { useKnownBusinessEntitiesContactsStore } from "@/store/known-business-entities-contacts.store.ts"
import { storeToRefs } from "pinia"
import { useRelatedObjectsManager } from "@/composables/socket/related-objects-manager.ts"
import type { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers.ts"

export class AvailabilityBlockController extends GenericModelController<
  AvailabilityBlock,
  IAvailabilityBlock,
  AvailabilityBlockRepository
> {
  constructor() {
    const { knownBusinessEntitiesContacts } = storeToRefs(useKnownBusinessEntitiesContactsStore())

    const { pushToRelatedObjects, removeFromRelatedObjects } = useRelatedObjectsManager(
      knownBusinessEntitiesContacts,
      (availabilityBlock: AvailabilityBlock) => availabilityBlock.availabilityBucket,
      (kbec: KnownBusinessEntityContact) => kbec.availabilityBucket?.id,
      (kbec: KnownBusinessEntityContact) => kbec.availabilityBucket?.availabilityBlocks
    )

    const storeFunctionsConfig = {
      onCreate: pushToRelatedObjects,
      onDelete: removeFromRelatedObjects
    }

    super(AvailabilityBlock, storeFunctionsConfig, new AvailabilityBlockRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      AvailabilityBlock,
      null,
      pushToRelatedObjects,
      removeFromRelatedObjects
    )
  }
}
